module.exports = __webpack_public_path__ + "static/media/minsights_intro.b4a531f8.jpg";